/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PredictorInputBase } from './PredictorInputBase';
import {
    PredictorInputBaseFromJSON,
    PredictorInputBaseFromJSONTyped,
    PredictorInputBaseToJSON,
    PredictorInputBaseToJSONTyped,
} from './PredictorInputBase';

/**
 * 
 * @export
 * @interface PredictorInput
 */
export interface PredictorInput {
    /**
     * 
     * @type {PredictorInputBase}
     * @memberof PredictorInput
     */
    base?: PredictorInputBase;
}

/**
 * Check if a given object implements the PredictorInput interface.
 */
export function instanceOfPredictorInput(value: object): value is PredictorInput {
    return true;
}

export function PredictorInputFromJSON(json: any): PredictorInput {
    return PredictorInputFromJSONTyped(json, false);
}

export function PredictorInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): PredictorInput {
    if (json == null) {
        return json;
    }
    return {
        
        'base': json['base'] == null ? undefined : PredictorInputBaseFromJSON(json['base']),
    };
}

export function PredictorInputToJSON(json: any): PredictorInput {
    return PredictorInputToJSONTyped(json, false);
}

export function PredictorInputToJSONTyped(value?: PredictorInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base': PredictorInputBaseToJSON(value['base']),
    };
}

